import _ from 'lodash';
import api from '@/api';
import { getField, updateField } from 'vuex-map-fields';

const state = () => ({
  query: {
    order_by: 'created_at',
    dir: 'asc',
    page: 1,
  },
  pagination: {
    data: [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}],
    current_page: 1,
    last_page: 1,
    path: null,
    per_page: 15,
    total: 11,
    from: null,
    to: null,
    first_page_url: null,
    last_page_url: null,
    next_page_url: null,
    prev_page_url: null,
  },
  fetching: false,
  message: null,
  choices: {
    order: [
      { text: 'Created At', value: 'created_at' },
      { text: 'Updated At', value: 'updated_at' },
    ],
  },
});

const getters = {
  getField,
  items: (state) => _.get(state, 'pagination.data', []),
};

const actions = {
  fetch: function(context) {
    context.commit('applyFetching', true);
    const promise = api.message.fetch(context.state.query);
    promise
      .then((response) => {
        context.commit('applyFetched', response.data);
      })
      .catch((e) => {})
      .then(() => {
        context.commit('applyFetching', false);
      });

    return promise;
  },
  show: function(context, uuid) {
    context.commit('applyFetching', true);
    const promise = api.message.show(uuid);
    promise
      .then((response) => {
        context.commit('applyFetchedSingle', response.data);
      })
      .catch((e) => {})
      .then(() => {
        context.commit('applyFetching', false);
      });

    return promise;
  },
  verify: function(context, uuid) {
    context.commit('applyFetching', true);
    const promise = api.message.verify(uuid);
    promise
      .then((response) => {
        // context.commit('applyFetchedSingle', response.data);
      })
      .catch((e) => {})
      .then(() => {
        context.commit('applyFetching', false);
      });

    return promise;
  },
  reject: function(context, uuid) {
    context.commit('applyFetching', true);
    const promise = api.message.reject(uuid);
    promise
      .then((response) => {
        // context.commit('applyFetchedSingle', response.data);
      })
      .catch((e) => {})
      .then(() => {
        context.commit('applyFetching', false);
      });

    return promise;
  },
  // cancel: function(context) {
  //   context.commit('instance/applyResetInstance', false);
  // },
};

const mutations = {
  updateField,

  applyFetching: function(state, status) {
    state.fetching = status;
  },
  applyFetchedSingle: function(state, message) {
    state.message = message;
  },
  applyFetched: function(state, data) {
    state.pagination = data;
  },
};

const modules = {
  // instance: instance,
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
  modules,
};
